import React, { useEffect, useMemo, useState } from "react";
import {
  DataGrid,
  itIT,
  GridToolbar,
  GridActionsCellItem,
  useGridApiRef,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { FormattedDate, FormattedNumber } from "react-intl";
import { newsStatus } from "../../helpers/enums";

import { postRequestGenerator } from "../../helpers/httpHelper";
import TableDeleteAction from "../TableDeleteAction";
import TableSellAction from "../TableSellAction";
import ModalAcquireNews from "./ModalSellNews";
import ModalSetRequiredPrice from "./ModalSetRequiredPrice";
import TableNicNoteAction from "../TableNicNoteAction";
import ModalSetNicNotes from "../ModalSetNicNotes";

const TableInsertedNews = ({
  newsData,
  setNewsData,
  tokenState,
  isAuthState,
  setIsAuthState,
  newsStatusState,
}) => {
  const [paginationState, setPaginationState] = useState(10);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState({
    open: false,
    id: undefined,
  });
  const [openSetModal, setOpenSetModal] = useState({
    open: false,
    id: undefined,
    newsId: undefined,
  });
  const [openNicNotesModal, setOpenNicNotesModal] = useState({
    open: false,
    id: undefined,
  });
  const [newRequiredPrice, setNewRequiredPrice] = useState(0.0);

  const recordsFromApi = newsData.map((e) => {
    return {
      completeObject: e,
      newsId: e.news.id,
      registrationDate: e.house.registrationDate,
      commercialFlag: e.commercialFlag.visual,
      owner: e.owner.visual,
      ownerContact: e.ownerContact.contact,
      requiredPrice: e.house.requiredPrice,
      houseAddress: e.address.visual,
      agreedCommission: e.news.agreedCommission,
    };
  });

  const onDelete = (id) => {
    return () => {
      const deleteApi = postRequestGenerator({
        url: `atomic/news/${id}`,
        queryType: "PATCH",
        tokenState: tokenState,
        isAuthState: setIsAuthState,
        body: { isActive: 0 },
      });
      setLoading(true);
      deleteApi().then((e) => {
        setNewsData(newsData.filter((e) => e.news.id !== id));
        setLoading(false);
      });
    };
  };

  const closeModal = () => {
    setOpenModal({
      ...openModal,
      open: false,
    });
    setOpenSetModal({
      ...openSetModal,
      open: false,
    });
  };

  const onClickOnNotes = (id) => {
    return () => {
      setOpenNicNotesModal({
        open: true,
        id: id,
      });
    };
  };

  const closeNicNotesModal = () => {
    setOpenNicNotesModal({
      ...openNicNotesModal,
      open: false,
    });
  };

  const onSell = (id) => {
    return () => {
      setOpenModal({
        open: true,
        id: id,
      });
    };
  };

  const openSetRequiredModal = (data) => {
    setOpenSetModal({
      open: true,
      id: data.row.completeObject.house.id,
      rowId: data.id,
    });
  };

  const onCLick = (data, e) => {
    e.preventDefault();

    // navigate(`/anagrafica/${data.id}`, {
    //   state: personData.filter((e) => e.people.id === data.id)[0],
    // });
  };

  const columns = useMemo(
    () => [
      {
        field: "newsId",
        headerName: "ID",
        width: 66.8,
      },
      {
        field: "registrationDate",
        headerName: "DATA",
        renderCell: (e) => <FormattedDate value={e.value} />,
        width: 80,
      },
      {
        field: "commercialFlag",
        headerName: "SEGNALATORE",
        width: 190,
      },
      {
        field: "owner",
        headerName: "PROPRIETARIO",
        width: 190,
      },
      {
        field: "ownerContact",
        headerName: "CONTATTO",
        width: 140,
      },
      {
        field: "requiredPrice",
        headerName: "RICHIESTA",
        width: 105,
        renderCell: (e) => (
          <>
            <FormattedNumber value={e.value} />
            {" €"}
          </>
        ),
      },
      {
        field: "agreedCommission",
        headerName: "PROVV.",
        width: 75,
        renderCell: (e) => <>{`${e.value}%`}</>,
      },
      {
        field: "houseAddress",
        headerName: "INDIRIZZO",
        width: 420,
        maxWidth: 420,
      },
      {
        field: "acquisisci",
        type: "actions",
        getActions: (params) => {
          return [
            <GridActionsCellItem
              icon={<TableNicNoteAction />}
              onClick={onClickOnNotes(params.id)}
              label="Notes"
            />,
            <GridActionsCellItem
              icon={<TableSellAction />}
              onClick={onSell(params.id)}
              label="Sell"
            />,
            <GridActionsCellItem
              icon={<TableDeleteAction />}
              onClick={onDelete(params.id)}
              label="Delete"
            />,
          ];
        },
      },
    ],
    [newsData]
  );

  return (
    <>
      <DataGrid
        onCellDoubleClick={openSetRequiredModal}
        loading={loading}
        showCellVerticalBorder={false}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={recordsFromApi}
        getRowId={(row) => row.newsId}
        initialState={{
          ...recordsFromApi,
          pagination: {
            paginationModel: { pageSize: paginationState, page: 0 },
          },
        }}
        pageSizeOptions={[5, 10, 20, 50]}
        sx={{
          boxShadow:
            "0px 5px 22px rgba(0, 0, 0, 0.05), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.035)",
          borderRadius: 3,
          border: 0,
        }}
        onRowDoubleClick={onCLick}
        slots={{
          toolbar: () => <GridToolbar sx={{ mb: 2 }} />,
        }}
      />
      <ModalAcquireNews
        open={openModal.open}
        id={openModal.id}
        closeModal={closeModal}
        newsData={newsData}
        tokenState={tokenState}
        isAuthState={isAuthState}
        setIsAuthState={setIsAuthState}
        setNewsData={setNewsData}
      />
      <ModalSetRequiredPrice
        open={openSetModal.open}
        id={openSetModal.id}
        rowId={openSetModal.rowId}
        closeModal={closeModal}
        newsData={newsData}
        tokenState={tokenState}
        isAuthState={isAuthState}
        setIsAuthState={setIsAuthState}
        setNewsData={setNewsData}
      />
      <ModalSetNicNotes
        patchEnabled
        open={openNicNotesModal.open}
        id={openNicNotesModal.id}
        closeNicNotesModal={closeNicNotesModal}
        newsData={newsData}
        tokenState={tokenState}
        isAuthState={isAuthState}
        setIsAuthState={setIsAuthState}
        setNewsData={setNewsData}
      />
    </>
  );
};

export default TableInsertedNews;
